import BaseModel from '../core/BaseModel'
import CategoriesModel from './CategoriesModel'
export default class ProductModel extends BaseModel {
    constructor() {
        super({ 
                name: "product",
                tableName: 'core_product'
            }, 
            {
            id: { 
                name: 'id', 
                type: "String", 
                label: 'ID', 
                primaryKey: true,
                display: false
            },
            thumbnail: { 
                name: 'thumbnail', 
                type: "Image", 
                label: 'Hình ảnh',
                class: 'center',
                width: 8,
                computed: (data) => {
                    if (data.thumbnails != null && data.thumbnails) {
                        data.thumbnail = (data.thumbnails.external_path != null ? data.thumbnails.external_path : (data.thumbnails.cdn_path != null && data.thumbnails.cdn_path != '' ? data.thumbnails.cdn_path + '' + data.thumbnails.local_path : data.thumbnails.local_path))
                    } else {
                        data.thumbnail = window.origin + '/assets/images/logo_HK-01.png'
                    }
                }
            },
            thumbnail_id: {
                refs: 'desc_product_advantages desc_product_application slug product_link warranty_time change_time returnable_time returnable_appraisal_time thumbnails  {  local_path cdn_path external_path  } description production_status qr_code_size is_manually_verification categories{ id name }  product_serial_number_aggregate(where: {production_status: {_eq: 1}}) { aggregate { count } }',
                display: false
            },
            model_code: {
                name: 'model_code', 
                type: "String", 
                label:'Model sản phẩm',
                width: 12,
                sortable: true,
                filter: { type: 'input', match: 'custom'}
            },
            name: { 
                name: 'name', 
                type: "String", 
                label: 'Tên sản phẩm',
                width: 18,
                sortable: true,
                filter: { type: 'input',  match: 'custom'}
            },
            category_id: { 
                name: 'category_id', 
                type: "Selection", 
                label: 'Nhóm sản phẩm',
                class: 'center',
                dataType: 'Label', 
                width: 18,
                sortable: true,
                params: {select: 'id, name', variables: {status: {'_in': [1]}}},
                models: new CategoriesModel(),
                filter: { type: 'select', display: false, optionLabel: 'label', optionKey: 'value', match: 'equals'}
            },
            warrantyTime: { 
                name: 'warranty_time', 
                type: "Number", 
                label: 'Tháng bảo hành',
                width: 8,
                class: 'center',
                sortable: true,
                computed: (data) => {
                    data.warrantyTime = (data.warranty_time !== undefined && data.warranty_time !== null) ?  data.warranty_time : 0;
                }
            },
            changeTime: { 
                name: 'change_time', 
                type: "Number", 
                label: 'Ngày đổi',
                width: 8,
                class: 'center',
                sortable: true,
                computed: (data) => {
                    data.changeTime = (data.change_time !== undefined && data.change_time !== null) ?  data.change_time : 0;
                }
            },
            returnableTime: { 
                name: 'returnable_time', 
                type: "Number", 
                label: 'Ngày trả',
                width: 8,
                class: 'center',
                sortable: true,
                computed: (data) => {
                    data.returnableTime = (data.returnable_time !== undefined && data.returnable_time !== null) ?  data.returnable_time : 0;
                }
            },
            production_status: {
                name: 'production_status', label: 'Trạng thái sản xuất', type: "Selection",  dataType: 'Label',  class: 'center', width: 10,
                options: [{ value: 1, label: 'Đang sản xuất'}, { value: 0, label: 'Ngưng sản xuất'}],
                filter: { type: 'select', display: false, optionLabel: 'label', optionKey: 'value', match: 'equals' }
            },
            serial_number: { 
                name: 'serial_number', 
                type: "Number", 
                label: 'SL serial number',
                class: 'center padding-content',
                dataType: 'Custom',
                sortable: true,
                callback: true,
                width: 8,
                linkCustom:  '<abbr class="external-link">{0}<span class="pi pi-external-link"></span></abbr>',
                computed: (data) => {
                    data.serial_number = (data.product_serial_number_aggregate !== undefined && data.product_serial_number_aggregate !== null) ?  data.product_serial_number_aggregate.aggregate.count : 0;
                }
            },
            history: {
                name: 'history', type: 'String', label: 'Lịch sử', class: 'center', width: 8,
                callback: true,
                computed: (data) => {
                    data.history = '<abbr class="external-link black-color bold"><span class="material-icons"> restore </span></abbr>';
                }
            },
            fied_detail: {
                refs: 'is_maintenance type_maintenance link_pdf link_youtube',
                display: false
            },
        },)
    }

}